export default "__VITE_ASSET__C48OqF5B__"